<script>
import { assignRole } from '@/api/user.js';

export default {
    computed: {
        roles() {
            return this.$store.getters.ROLES;
        },
        userRole() {
            return this.$store.getters.ROLES_BY_ID(
                this.userEditData.user_role_id
            );
        },
        userEditData() {
            return this.$store.getters.USER_EDIT_DATA;
        },
        permission() {
            return this.$store.getters.CONST_PERMISSIONS;
        },
    },
    methods: {
        async changeRole(event) {
            this.$store.commit('USER_EDIT_UPDATE', {
                userRoleID: event.target.value,
            });
        },
        async saveRole() {
            const response = await assignRole(
                this.userEditData.id,
                this.userEditData.user_role_id
            );
            if (response === true) {
                this.$store.commit('USER_SET_DATA', {
                    id: this.userEditData.id,
                    userRoleID: this.userEditData.user_role_id,
                });
            }
        },
    },
};
</script>

<template>
    <div class="left_sub_panel_data">
        <div class="left_sub_multi_container mb_10">
            <select
                v-model="userEditData['user_role_id']"
                @click="changeRole"
                class="right_input"
            >
                <option
                    v-for="(roleValue, roleIndex) in roles"
                    :key="roleIndex"
                    :value="roleValue['id']"
                >
                    {{ roleValue['name'] }}
                </option>
            </select>
            <button class="button_blue_100 ml_10" @click="saveRole">
                Save
            </button>
        </div>
        <ul class="ul_2_columns">
            <li
                v-for="(permissionValue, permissionIndex) in permission"
                :key="permissionIndex"
            >
                <label class="name"> {{ permissionValue['name'] }}: </label>
                <label
                    :class="
                        userRole[permissionValue['id']] == true
                            ? 'ml_5 green_color'
                            : 'ml_5 red_color'
                    "
                >
                    {{ userRole[permissionValue['id']] }}
                </label>
            </li>
        </ul>
    </div>
</template>

<style scoped>
.green_color {
    color: #00d25b;
}
.red_color {
    color: #fc424a;
}

li {
    display: flex;
}
li > label.name {
    flex: 0 0 80%;
}
li > label.status {
    flex: 0 0 20%;
}
</style>
